// GENERATED by scripts/site_photos.py from the Tappd imagery library: do not edit by hand.
// Per image id: the brief's alt text and, per ratio, the shipped widths (public/images/site/photos/
// <id>-<ratio>-<width>.webp), the largest size and the focal point (x %, y %).
const SITE_PHOTO_DATA = Object.freeze({
  "HOME-HERO-01": {
    "alt": "A guest scans a Tappd coaster with their phone at a neighborhood bar table.",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          53.0,
          69.0
        ],
        "composite": true
      },
      "4x5": {
        "widths": [
          810,
          1080,
          1620
        ],
        "width": 1620,
        "height": 2025,
        "focal": [
          51.3,
          69.0
        ],
        "composite": true
      }
    }
  },
  "HOME-AUD-01": {
    "alt": "A local shop owner smiles in the doorway of her business.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "HOME-AUD-02": {
    "alt": "A bar owner preps the bar next to a stack of Tappd coasters.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "HOME-AUD-03": {
    "alt": "Two friends at a bar booth look at a local offer on a phone.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "HOME-CH-01": {
    "alt": "A Tappd coaster under a pint on a bar table.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          51.0,
          69.0
        ],
        "composite": true
      }
    }
  },
  "HOME-CH-02": {
    "alt": "A guest browses local offers on their phone at the bar.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          48.0,
          45.0
        ],
        "composite": true
      }
    }
  },
  "HOME-CH-03": {
    "alt": "A customer shows an offer code on their phone at a local bike shop.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          48.0,
          54.0
        ],
        "composite": true
      }
    }
  },
  "HOME-BIZ-01": {
    "alt": "A local business owner holds up her ad printed on a Tappd coaster.",
    "ratios": {
      "4x5": {
        "widths": [
          810,
          1080,
          1620
        ],
        "width": 1620,
        "height": 2025,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "HOME-VEN-01": {
    "alt": "A bartender fans out a fresh stack of free Tappd coasters on the bar.",
    "ratios": {
      "4x5": {
        "widths": [
          810,
          1080,
          1620
        ],
        "width": 1620,
        "height": 2025,
        "focal": [
          52.0,
          51.0
        ]
      }
    }
  },
  "HOME-REP-01": {
    "alt": "A monthly Tappd activity report open on a laptop at a local shop counter.",
    "ratios": {
      "16x10": {
        "widths": [
          1440,
          2160
        ],
        "width": 2160,
        "height": 1350,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "HOME-CTA-01": {
    "alt": "",
    "ratios": {
      "21x9": {
        "widths": [
          1680,
          2520
        ],
        "width": 2520,
        "height": 1080,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "HIW-HERO-01": {
    "alt": "Three hands meet at one Tappd coaster: a guest, a bartender and a local business owner.",
    "ratios": {
      "21x9": {
        "widths": [
          1680,
          2520
        ],
        "width": 2520,
        "height": 1080,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      },
      "4x5": {
        "widths": [
          810,
          1080,
          1620
        ],
        "width": 1620,
        "height": 2025,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "HIW-G-01": {
    "alt": "Scanning the QR code on a Tappd coaster with a phone camera.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "HIW-G-02": {
    "alt": "Browsing local offers after scanning a coaster.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "HIW-G-03": {
    "alt": "Claiming an offer by entering an email address.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "HIW-G-04": {
    "alt": "A customer shows an offer code at a local café.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "HIW-B-01": {
    "alt": "A business owner creates a free Tappd listing.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "HIW-B-02": {
    "alt": "Business owners choose which venues to appear at.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "HIW-B-03": {
    "alt": "Coaster artwork printed in the quarterly print run.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "HIW-B-04": {
    "alt": "A business owner reviews her monthly Tappd report.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "HIW-V-01": {
    "alt": "A bar owner fills out the Tappd venue application.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "HIW-V-02": {
    "alt": "A venue owner reviews a coaster proof with the Tappd team.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "HIW-V-03": {
    "alt": "A box of free Tappd coasters delivered to a venue.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "HIW-V-04": {
    "alt": "Tappd coasters in use along a busy bar.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "BIZ-HERO-01": {
    "alt": "A guest picks up a Tappd coaster to read the local business ad printed on it.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          48.0,
          48.8
        ],
        "composite": true
      },
      "4x5": {
        "widths": [
          810,
          1080,
          1620
        ],
        "width": 1620,
        "height": 2025,
        "focal": [
          48.0,
          49.0
        ],
        "composite": true
      }
    }
  },
  "BIZ-TIER-01": {
    "alt": "The back of a Tappd coaster with a grid of local business logo tiles, one highlighted.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "BIZ-TIER-02": {
    "alt": "A Tappd coaster with one business's full-color ad covering the front.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "BIZ-TIER-03": {
    "alt": "Two Tappd coasters showing one sponsor's artwork on both the front and the back.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "BIZ-CAT-01": {
    "alt": "A local realtor outside a neighborhood home.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          40.0,
          43.0
        ]
      }
    }
  },
  "BIZ-CAT-02": {
    "alt": "A stylist in a neighborhood hair salon.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          49.0,
          42.0
        ]
      }
    }
  },
  "BIZ-CAT-03": {
    "alt": "A coach at a community gym.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          58.0,
          43.0
        ]
      }
    }
  },
  "BIZ-CAT-04": {
    "alt": "A boutique owner arranging her shop.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          53.0,
          45.0
        ]
      }
    }
  },
  "BIZ-CAT-05": {
    "alt": "A mechanic at a local auto repair shop.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          41.0,
          45.0
        ]
      }
    }
  },
  "BIZ-CAT-06": {
    "alt": "A pet store owner with a dog in her shop.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          49.0,
          48.0
        ]
      }
    }
  },
  "VEN-HERO-01": {
    "alt": "A bartender serves a pint on a free Tappd coaster printed with the venue's name.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          42.0,
          71.2
        ]
      },
      "4x5": {
        "widths": [
          810,
          1080,
          1620
        ],
        "width": 1620,
        "height": 2025,
        "focal": [
          42.0,
          67.0
        ]
      }
    }
  },
  "VEN-BEN-01": {
    "alt": "A coaster printed with a venue's own name and QR code.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          55.0,
          66.0
        ]
      }
    }
  },
  "VEN-BEN-02": {
    "alt": "A delivery box of free coasters, printed and packed by Tappd.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          60.0,
          67.0
        ]
      }
    }
  },
  "VEN-BEN-03": {
    "alt": "A bartender grabs a Tappd coaster from the caddy during service.",
    "ratios": {
      "1x1": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 1200,
        "focal": [
          69.0,
          51.0
        ]
      }
    }
  },
  "VEN-GUEST-01": {
    "alt": "A guest smiles at a local offer on her phone after scanning a coaster.",
    "ratios": {
      "4x5": {
        "widths": [
          810,
          1080,
          1620
        ],
        "width": 1620,
        "height": 2025,
        "focal": [
          50.0,
          50.0
        ],
        "composite": true
      }
    }
  },
  "VEN-TOWN-01": {
    "alt": "A small-town main street lined with local businesses at golden hour.",
    "ratios": {
      "16x9": {
        "widths": [
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "PRC-FREE-01": {
    "alt": "A free Tappd business listing shown on a phone.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          55.0,
          68.0
        ],
        "composite": true
      }
    }
  },
  "STORY-BEFORE-01": {
    "alt": "A pint on a soggy napkin: the plain space under a drink that Tappd started with.",
    "ratios": {
      "4x3": {
        "widths": [
          800,
          1200
        ],
        "width": 1200,
        "height": 900,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "STORY-HOME-01": {
    "alt": "A quiet pine-lined lake in South Jersey at golden hour.",
    "ratios": {
      "21x9": {
        "widths": [
          1680,
          2520
        ],
        "width": 2520,
        "height": 1080,
        "focal": [
          33.0,
          74.0
        ]
      }
    }
  },
  "DEALS-HERO-01": {
    "alt": "Friends at a bar booth discovering local offers on a phone.",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          70.0,
          48.0
        ],
        "composite": true
      },
      "4x5": {
        "widths": [
          810,
          1080,
          1620
        ],
        "width": 1620,
        "height": 2025,
        "focal": [
          63.0,
          44.0
        ],
        "composite": true
      }
    }
  },
  "PLACE-HERO-01": {
    "alt": "Coasters placed like pins on a map of South Jersey towns.",
    "ratios": {
      "16x9": {
        "widths": [
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "FREE-SIDE-01": {
    "alt": "A café owner sets up a free Tappd listing on her phone.",
    "ratios": {
      "4x5": {
        "widths": [
          810,
          1080,
          1620
        ],
        "width": 1620,
        "height": 2025,
        "focal": [
          68.0,
          47.0
        ],
        "composite": true
      }
    }
  },
  "APPLY-SIDE-01": {
    "alt": "A restaurant owner applies for free Tappd coasters before opening.",
    "ratios": {
      "4x5": {
        "widths": [
          810,
          1080,
          1620
        ],
        "width": 1620,
        "height": 2025,
        "focal": [
          67.0,
          57.0
        ],
        "composite": true
      }
    }
  },
  "VENUE-FALLBACK-01": {
    "alt": "A participating neighborhood venue.",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "VENUE-FALLBACK-02": {
    "alt": "A participating neighborhood venue.",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "VENUE-FALLBACK-03": {
    "alt": "A participating neighborhood venue.",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "CAT-01": {
    "alt": "{Business name}, {category} in {town}",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "CAT-02": {
    "alt": "{Business name}, {category} in {town}",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "CAT-03": {
    "alt": "{Business name}, {category} in {town}",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "CAT-04": {
    "alt": "{Business name}, {category} in {town}",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "CAT-05": {
    "alt": "{Business name}, {category} in {town}",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "CAT-06": {
    "alt": "{Business name}, {category} in {town}",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "CAT-07": {
    "alt": "{Business name}, {category} in {town}",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "CAT-08": {
    "alt": "{Business name}, {category} in {town}",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  },
  "CAT-09": {
    "alt": "{Business name}, {category} in {town}",
    "ratios": {
      "16x9": {
        "widths": [
          800,
          1200,
          1440,
          2160
        ],
        "width": 2160,
        "height": 1215,
        "focal": [
          50.0,
          50.0
        ]
      }
    }
  }
});

export default SITE_PHOTO_DATA;
